import { CardContent } from "@mui/material";

import commoncss from "../../myfin_v2/css/common.module.css";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";

const AddFooters = ({
  checkBoxList = [],
  selectedItems = [],
  setSelectedItems,
}) => {
  const handleCheckboxChange = (value) => {
    setSelectedItems((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const handleSelectAll = (checked) => {
    setSelectedItems(
      checked ? checkBoxList.map((i) => i.value) : []
    );
  };

  const isAllSelected =
    checkBoxList.length > 0 &&
    selectedItems.length === checkBoxList.length;

  return (
    <CardContent>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          alignItems: "center",
          padding: "0 10px",
          gap:"20px"
        }}
      >
        <span className={commoncss.label3}>Add Footer to:</span>

        <label className="d-flex align-items-center gap-1 cursor-pointer">
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            className={adminPortalCss.customCheckbox}
          />
          <span className={`${commoncss.label6} ${commoncss.fs14}`}>
            Select All
          </span>
        </label>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "12px",
          padding: "12px",
        }}
      >
        {checkBoxList.map(({ label, value }) => (
          <label
            key={value}
            className="d-flex align-items-center gap-1 cursor-pointer"
          >
            <input
              type="checkbox"
              checked={selectedItems.includes(value)}
              onChange={() => handleCheckboxChange(value)}
              className={adminPortalCss.customCheckbox}
            />
            <span
              className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs16}`}
            >
              {label}
            </span>
          </label>
        ))}
      </div>
    </CardContent>
  );
};

export default AddFooters;
